import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Circuit breaker contra reload-loop: se a página reiniciar >=3 vezes em <5s,
// para de renderizar e oferece limpeza manual. Em condição normal, o setTimeout
// reseta o contador e o usuário nem nota.
const RELOAD_KEY = '__reload_loop_counter'
const reloadCount = parseInt(sessionStorage.getItem(RELOAD_KEY) || '0', 10) + 1
sessionStorage.setItem(RELOAD_KEY, String(reloadCount))
if (reloadCount >= 3) {
  sessionStorage.setItem(RELOAD_KEY, '0')
  document.body.innerHTML = `
    <div style="padding:40px;text-align:center;font-family:system-ui,sans-serif;color:#111">
      <h1 style="color:#b42318">Detectamos um loop de recarregamento</h1>
      <p>Algo está fazendo a página recarregar repetidamente.</p>
      <button onclick="sessionStorage.clear();localStorage.clear();location.reload()"
              style="margin:8px;padding:10px 18px;font-size:15px;cursor:pointer;border-radius:8px;border:1px solid #d1d1cb;background:#fff">
        Limpar dados e tentar de novo
      </button>
      <button onclick="location.reload()"
              style="margin:8px;padding:10px 18px;font-size:15px;cursor:pointer;border-radius:8px;border:1px solid #d1d1cb;background:#fff">
        Apenas recarregar
      </button>
    </div>
  `
  throw new Error('Reload loop detected — execution halted')
}
setTimeout(() => sessionStorage.setItem(RELOAD_KEY, '0'), 5000)

// Silenciar console.log/info/debug em prod (mantém warn/error pra incidentes).
if (import.meta.env?.PROD) {
  const noop = () => {}
  console.log = noop
  console.info = noop
  console.debug = noop
}

// Tornar listeners de scroll/touch/wheel passivos por padrão.
if (typeof window !== 'undefined') {
  let supportsPassive = false
  try {
    const opts = Object.defineProperty({}, 'passive', { get() { supportsPassive = true } })
    window.addEventListener('__feat', null as any, opts)
    window.removeEventListener('__feat', null as any, opts)
  } catch {}

  if (supportsPassive) {
    const passiveEvents = new Set(['wheel', 'mousewheel', 'touchstart', 'touchmove'])
    const addEvent = EventTarget.prototype.addEventListener
    EventTarget.prototype.addEventListener = function (type: any, listener: any, options?: any) {
      if (passiveEvents.has(type)) {
        if (options && typeof options === 'object') {
          if (!('passive' in options)) options.passive = true
        } else {
          options = { capture: !!options, passive: true }
        }
      }
      return addEvent.call(this, type, listener, options)
    }
  }
}

// NÃO ponha aqui código que siga o `prefers-color-scheme` do SO. Existiu até
// 08/08/2026 e contradizia os dois donos legítimos do tema — o script
// anti-flash do `index.html` e o `ThemeContext` —, que têm CLARO como default
// e só vão pro escuro por escolha na lua da sidebar. Como rodava antes do
// render, quem usa o SO no escuro pegava: flash escuro no boot (o
// ThemeProvider só corrige no useEffect, depois do paint); tela escura
// PERMANENTE em toda rota que não monta o ThemeProvider (`/mapa` e o wizard,
// que retornam antes dele em App.tsx); e o listener de `change`, que ficava
// vivo e reaplicava `dark` se o SO trocasse com o app aberto, sem ninguém pra
// remover. A landing já tinha fugido disto com entry próprio (landing/main.tsx).

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
